/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';


export default $ => css`
  .main-container {
    padding-left: calc(${$.sidebarContentWidth} + 1rem);
  }
`;
